import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import arrowCollapse from '../../assets/img/icons/arrow-collapse.svg';
import officeIcon from '../../assets/img/icons/black-site-icon.svg';
import editWhiteIcon from '../../assets/img/icons/edit-white.svg';
import locationIcon from '../../assets/img/icons/jobsite.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import SearchWithButton from '../../components/Search/SearchWithButton';
import { PrimaryButton } from '../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  InputField,
} from '../../styledComponents/common';
import {
  EditButton,
  HoveredSection,
  ListItemsContainer,
  NoDataContainer,
  SingleSiteItem,
} from '../FieldServices/JobSites/jobSitesStyles';
import { ExpandIcon } from '../Projects/projectsStyles';
import { InfoSection, LocationItem, LocationRegion } from './officesStyles';

const OfficeList = props => {
  const [hoveredId, setHoveredId] = useState(null);
  const [list, setList] = useState([]);
  const [expandedOffices, setExpandedOffices] = useState({});

  const { t } = useTranslation();

  const {
    handleChangePage,
    officesList,
    selectedOffice,
    selectedLocation,
    selectOffice,
    selectLocation,
    isLoading,
    toggleDeleteModal,
    searchTerm,
    onSearchTermChange,
  } = props;
  useEffect(() => {
    if (officesList && officesList.length > 0) {
      setList(officesList);
    } else if (officesList && officesList.length === 0) {
      setList([]);
    }
  }, [officesList]);

  // Automatically expand selected office
  useEffect(() => {
    if (selectedOffice && selectedOffice.id) {
      setExpandedOffices(prev => ({
        ...prev,
        [selectedOffice.id]: true,
      }));
    }
  }, [selectedOffice]);

  useEffect(() => {
    if (
      searchTerm &&
      searchTerm !== '' &&
      officesList &&
      officesList.length > 0
    ) {
      const originalList = JSON.parse(JSON.stringify(officesList));
      const filteredList = [];
      originalList.forEach(e => {
        if (
          searchTerm &&
          e.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) === -1
        ) {
          return;
        }
        filteredList.push(e);
      });
      setList(filteredList);
    } else if (searchTerm === '') {
      setList(officesList);
    }
  }, [searchTerm]);

  const onHoverChange = id => {
    setHoveredId(id);
  };

  const toggleOfficeExpansion = officeId => {
    setExpandedOffices(prev => ({
      ...prev,
      [officeId]: !prev[officeId],
    }));
  };

  return (
    <div>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : officesList && officesList.length > 0 ? (
        <>
          <InfoSection>
            <CommonGrid margin="0 0 20px">
              <CommonText name title fontSize="14px">
                {t('offices')}
              </CommonText>
              {localStorage.getItem('user_role') === 'admin' &&
              !localStorage.getItem('viewer_role') ? (
                <ColoredText
                  fontSize="13px"
                  type="success"
                  hover
                  semibold
                  style={{ cursor: `pointer` }}
                  onClick={() => handleChangePage('details', null)}
                >
                  {t('create_office')}
                </ColoredText>
              ) : null}
            </CommonGrid>
            {/* <SearchWithButton
              itemName={t("office")}
              searchTermName={t("search_office")}
              searchInput={searchTerm}
              onInputChange={onSearchTermChange}
              handleSearch={handleSearchByName}
              handleClearSearch={handleClearSearch}
            /> */}
            <InputField
              placeholder={t('search_office')}
              value={searchTerm}
              onChange={onSearchTermChange}
            />
          </InfoSection>

          <ListItemsContainer>
            {list.map((office, index) => {
              return (
                <div key={office.id}>
                  <SingleSiteItem
                    isActive={
                      selectedOffice &&
                      selectedOffice.id &&
                      selectedOffice.id === office.id
                    }
                    onClick={() => {
                      selectOffice(office);
                      toggleOfficeExpansion(office.id);
                    }}
                    onMouseEnter={() => onHoverChange(office.id)}
                    onMouseLeave={() => onHoverChange(null)}
                  >
                    <CommonFlex justifyContent="space-between">
                      <CommonFlex gap="10px">
                        <CommonImage src={officeIcon} alt="" size="35px" />
                        <CommonText fontWeight="600">{office.name}</CommonText>
                        {office.code && (
                          <CommonText fontSize="12px" $label>
                            ({office.code})
                          </CommonText>
                        )}
                      </CommonFlex>{' '}
                      {office.locations && office.locations.length > 0 && (
                        <ExpandIcon
                          src={arrowCollapse}
                          alt="aa"
                          onClick={e => {
                            e.stopPropagation();
                            toggleOfficeExpansion(office.id);
                          }}
                          style={{
                            rotate: '-90deg',
                          }}
                          open={expandedOffices[office.id]}
                        />
                      )}
                    </CommonFlex>
                    {localStorage.getItem('user_role') === 'admin' &&
                    !localStorage.getItem('viewer_role') &&
                    hoveredId &&
                    hoveredId === office.id ? (
                      <HoveredSection>
                        <EditButton
                          onClick={e => {
                            e.stopPropagation();
                            handleChangePage('details', office);
                          }}
                        >
                          <CommonImage src={editWhiteIcon} alt="" size="26px" />
                        </EditButton>
                      </HoveredSection>
                    ) : null}
                  </SingleSiteItem>

                  {/* Display locations if office is expanded */}
                  {expandedOffices[office.id] &&
                    office.locations &&
                    office.locations.length > 0 && (
                      <div>
                        {office.locations.map(location => (
                          <LocationItem
                            key={location.id}
                            active={
                              selectedLocation &&
                              selectedLocation.id === location.id
                            }
                            onClick={e => {
                              e.stopPropagation();
                              selectOffice(office, location);
                            }}
                          >
                            {' '}
                            <CommonImage
                              src={locationIcon}
                              alt=""
                              size="18px"
                            />
                            <CommonText
                              fontSize="13px"
                              fontWeight={
                                selectedLocation &&
                                selectedLocation.id === location.id
                                  ? '600'
                                  : '500'
                              }
                              color={
                                selectedLocation &&
                                selectedLocation.id === location.id
                                  ? 'primary'
                                  : ''
                              }
                            >
                              {location.name ||
                                location.address ||
                                `${location.latitude}, ${location.longitude}`}
                            </CommonText>
                            {location.region && (
                              <LocationRegion>{t(location.region)}</LocationRegion>
                            )}
                          </LocationItem>
                        ))}
                      </div>
                    )}
                </div>
              );
            })}
          </ListItemsContainer>
        </>
      ) : (
        <NoDataContainer>
          <CommonImage src={officeIcon} alt="" size="35px" />
          <CommonText fontSize="15px" fontWeight="600" margin="20px 0 0">
            No Offices!
          </CommonText>
          <CommonText $label fontSize="13px" fontWeight="500" margin="15px 0 0">
            Add your very first office
          </CommonText>
          <PrimaryButton
            margin="30px 0 0"
            onClick={() => handleChangePage('details', null)}
          >
            {t('create_office')}
          </PrimaryButton>
        </NoDataContainer>
      )}
    </div>
  );
};

export default OfficeList;
